export default __webpack_public_path__ + "da8bb527039ba333c18fadce5305f906.svg";